import PostModal from "./components/PostModal";
import UserModal from "./components/UserModal";
import GroupModal from "./components/chat/GroupModal"; // ✅ добавили

import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [postModal, setPostModal] = useState(null);
  const [userModal, setUserModal] = useState(null);
  const [groupModal, setGroupModal] = useState(null); // ✅ НОВОЕ

  return (
    <ModalContext.Provider
      value={{
        postModal,
        setPostModal,

        userModal,
        setUserModal,

        groupModal,      // ✅
        setGroupModal,   // ✅
      }}
    >
      {children}

      {/* 👇 ГЛОБАЛЬНЫЕ МОДАЛКИ */}
      {postModal && <PostModal data={postModal} />}
      {userModal && <UserModal data={userModal} />}

      {/* ✅ НОВАЯ МОДАЛКА ГРУППЫ */}
      {groupModal && (
        <GroupModal
          group={groupModal}
          onClose={() => setGroupModal(null)}
        />
      )}
    </ModalContext.Provider>
  );
}